import * as userRequest from "@/utils/userRequest";

export default async function getCampaignsService(
    body?: {
        token: string;
        time?: number;
    },
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    let path = "";
    if (body?.time != undefined) {
        path = `?time=${body?.time}`;
    }
    try {
        const res = await userRequest.get("campaign/user-campaign" + path, {
            headers: {
                Authorization: `Bearer ${body?.token}`,
            },
        });
        if (res) {
            onSuccess && onSuccess(res);
            return res;
        }
    } catch (err) {
        console.error("🚀 ~ boostFakeService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
